import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-dropdown-container',
  templateUrl: './dropdown-container.component.html',
  styleUrls: ['./dropdown-container.component.scss'],
})
export class DropdownContainerComponent implements OnInit, OnDestroy, OnChanges {

  @Output() filterSelection = new EventEmitter();
  @Output() filterSelectionMore = new EventEmitter();
  @Output() applyMore = new EventEmitter();
  @Output() closeMore = new EventEmitter();
  @Output() clearAllMore = new EventEmitter();

  globalListenFunc: Function;

  constructor(private _eref: ElementRef, private renderer: Renderer2) {}

  @Input() filter;
  @Input() showDropdown;
  @Input() more;
  @Input() filters;

  @Input() searchedFilters;
  @Input() filtersSelected;
  @Input() filtersSelectedNoDeselect;
  @Input() searchType;

  ngOnChanges(changes: SimpleChanges) {
    if (this.showDropdown) {
      setTimeout(() => {
        this.globalListenFunc = this.renderer.listen('document', 'click', (evt) => {
          if (!this._eref.nativeElement.contains(evt.target)) {
            if (this.more) {
              this.closeMore.emit(true);
            } else {
              this.filter.showDropdown = false;
            }
            if (this.globalListenFunc) {
              this.globalListenFunc();
            }
          }
        });
      }, 100);
    } else {
      if (this.globalListenFunc) {
        this.globalListenFunc();
      }
    }
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    if (this.globalListenFunc) {
      this.globalListenFunc();
    }
  }



  selectOption(filter, key) {

    const obj = {
      filter: filter,
      key: key
    };

    this.filterSelection.emit(obj);
    if (this.more) {
      this.closeMore.emit(true);
    } else {
      this.filter.showDropdown = false;
    }
    if (this.globalListenFunc) {
      this.globalListenFunc();
    }
  }

  selectOptionMore(filter, key) {

    const obj = {
      filter: filter,
      key: key
    };

    this.filterSelectionMore.emit(obj);
  }

  clickApplyMore() {
    this.applyMore.emit(true);
  }

  clickClearAllMore(event) {
    this.clearAllMore.emit(event);
  }

  clickShowMoreAll(filter) {
    filter.showMoreAll = !filter.showMoreAll;
  }

  clickCancelMore() {
    if (this.more) {
      this.closeMore.emit(true);
    }
    if (this.globalListenFunc) {
      this.globalListenFunc();
    }
  }

}
